<template>
  <div>
    <div>
      <b-checkbox v-if="availablePreferredVendors.length > 0" :size="size" :value="preferredOnly" @input="togglePreferred" :class="{'has-text-weight-medium has-text-primary':preferredOnly}">
        Preferred Vendors Only
      </b-checkbox>

      <!-- Brands selection section in filter --> 
      <div style="overflow-y:auto;max-height: 150px">
      <div
        v-for="(brand, index) in visibleBrands"
        :key="index"
        :data-id="brand.code"
        data-test="brand_filter_option"
      >
        <b-checkbox
          :size="size"
          :native-value="brand"
          :id="brand"
          :value="selectedBrands"
          :disabled="preferredOnly"
          @input="handleBrandInput"
        >
          {{ brand.name }}
          <b-tag v-if="false && brand.resultsCount > 0" rounded class="brand-count"
            >{{ brand.resultsCount }}
          </b-tag>
        </b-checkbox>
      </div>
    </div>

      <hr class="dropdown-divider" />
    </div>
          <div v-if="preferredOnly">
        <div
          v-for="(chain, index) in preferredChains"
          :key="index"
          :data-id="chain.code"
        >
          <b-checkbox
            :size="size"
            :native-value="chain"
            :id="chain"
            :value="selectedChains"
            :disabled="!isAvailable(chain) && !isSelected(chain)"
            @input="handleInput"
          >
            {{ chain.name }}
            <b-tag v-if="chain.resultsCount > 0" rounded class="chain-count"
              >{{ chain.resultsCount }}
            </b-tag>
          </b-checkbox>
        </div>
      </div>
    <div style="overflow-y:auto;max-height: 500px">
      <div
        v-for="(chain, index) in visibleChains"
        :key="index"
        :data-id="chain.code"
        data-test="chain_filter_option"
      >
        <b-checkbox
          :size="size"
          :native-value="chain"
          :id="chain"
          :value="selectedChains"
          :disabled="!isAvailable(chain) && !isSelected(chain)"
          @input="handleInput"
        >
          {{ chain.name }}
          <b-tag v-if="chain.resultsCount > 0" rounded class="chain-count"
            >{{ chain.resultsCount }}
          </b-tag>
        </b-checkbox>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ChainSelection",
  data() {
    return {};
  },
  props: {
    availableChains: Array,
    filteredChains: Array,
    selectedChains: Array,
    preferredVendors: Array,
    preferredOnly: Boolean,
    size: {
      type: String,
      default: "is-small",
    },
    availableBrands: Array,
    selectedBrands: Array
  },
  computed: {
    availablePreferredVendors() {
      let availablePreferredVendors = [];
      let vendorList = this.preferredVendors;

      if (vendorList) {
        for (let code of vendorList) {
          let vendor = this.availableChains.find((p) => p.code === code);
          if (vendor) {
            availablePreferredVendors.push(vendor);
          }
        }
      }

      return availablePreferredVendors;
    },

    /*sortedChains() {
      if (this.preferredOnly) {
        let sorted = [...this.availableChains].sort((a, b) => {
          if (this.preferredVendors.includes(a.code)) {
            return -1;
          }
        });
        return sorted;
      } else {
        return this.availableChains;
      }
    },
    */

    //To hide all non-preferred vendors, use this instead of availableChains in the template
    preferredChains() {
      return this.availableChains.filter((item) =>
        this.preferredVendors.includes(item.code)
      );
    },

    visibleChains() {
      if (this.preferredOnly) {
        return this.availableChains.filter(
          (item) => !this.preferredVendors.includes(item.code)
        );
      } else {
        return this.availableChains;
      }
    },

    visibleBrands() {
      return this.availableBrands;
    }
  },
  methods: {
    handleInput(val) {
      this.$emit("input", val);
    },
    handleBrandInput(val) {
      this.$emit("brandInput", val);
    },
    togglePreferred() {
      let selected = [];
      if (this.preferredOnly) {
        this.$emit("update:preferredOnly", false);
      } else {
        selected = this.availablePreferredVendors;
        this.$emit("update:preferredOnly", true);
        this.$emit("brandInput", []);
      }
      this.$emit("input", selected);
    },
    isAvailable(chain) {
      let isAvailable =
        this.filteredChains.findIndex((i) => i.code == chain.code) > -1;

      if (this.preferredOnly) {
        let isPreferred =
          this.preferredVendors.findIndex((i) => i == chain.code) > -1;
        return isAvailable && isPreferred;
      } else {
        return isAvailable;
      }
    },
    isSelected(chain) {
      return this.selectedChains.findIndex((i) => i.code == chain.code) > -1;
    },
    /*
    getCount(chain) {
      let count = 0;
      let found = this.filteredChains.filter((i) => i.code == chain.code);
      if (found) {
        count = found.length;
      }
      return count;
    },
    */
  },
};
</script>

<style lang="scss" scoped></style>
